export default __webpack_public_path__ + "static/media/sold-out@2x.4af4b25a.png";